import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My twitter goals",
  "description": "",
  "published": "2008-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/my-twitter-goals/swizec/43"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Initially I wanted to write this as a comment to `}<a parentName="p" {...{
        "href": "http://www.twitip.com/defining-twitter-goals-a-tip-for-successful-use-of-twitter/"
      }}>{`TwiTip.com's Twitter goals post`}</a>{`, but it grew and grew and felt more like a blogpost of its own.`}</p>
    <p>{`I use twitter to be a popular twitterer. That's the only goal I really have.`}</p>
    <p>{`But there are hidden goals of course. Like just `}{`_`}{`what`}{`_`}{` comes from being a powerful twitterer? Well there's the personal branding thing, everyone's doing it right now and it's useful for a number of things pretty much everyone knows. Another thing powerful twitterers have is an instant readerbase, have a new project? Announce it on twitter and instantly hundreds of people know about it ... that's a very powerful promotion tool.`}</p>
    <p>{`Last but not least, is the knowledge aspect of being a powerful twitterer. You find out many things, very many things you find out near instantly and a lot of that information is in fact very good, useful information. The old saying goes "Valuable information is only valuable while it's fresh". Ding ding.`}</p>
    <p>{`So yeah, twitter goals, I say don't go overboard, just go out there and have fun. The rest will follow.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      